import * as React from "react";
const SvgFiRrFacePersevering = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-persevering_svg__a)">
      <path
        fill="#062147"
        d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10m3.598-4.802a1 1 0 0 1-1.196 1.603c-.007-.005-1.113-.802-2.402-.802s-2.396.797-2.406.805a1 1 0 0 1-1.396-.213 1 1 0 0 1 .205-1.394c.066-.049 1.632-1.198 3.598-1.198s3.531 1.149 3.598 1.198zm3.364-8.924a1 1 0 0 1-1.236.688c-1.403-.401-2.793-1.336-3.539-2.381a1 1 0 0 1 1.627-1.163c.484.678 1.497 1.344 2.461 1.619.531.152.839.705.688 1.236zm-12.688.688a1 1 0 0 1-.548-1.924c.964-.275 1.977-.941 2.461-1.619a1 1 0 1 1 1.627 1.163c-.746 1.045-2.136 1.979-3.539 2.381zm11.28 2.87L15.802 13l1.752 1.168a1 1 0 1 1-1.11 1.664l-3-2a1 1 0 0 1 0-1.664l3-2a1 1 0 1 1 1.11 1.664m-7 2-3 2a1 1 0 0 1-1.387-.277 1 1 0 0 1 .277-1.387L8.196 13l-1.752-1.168a1 1 0 1 1 1.11-1.664l3 2a1 1 0 0 1 0 1.664"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-persevering_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFacePersevering;
